export const ITEM_UNAVAILABLE = {
  name: 'item-unavailable',
};

export const NO_SITE_ACCESS = {
  name: 'no-site-access',
  path: '/no-site-access',
};

export const FEATURE_MAINTENANCE_MODE = {
  name: 'feature-maintenance-mode',
};

export const NOT_FOUND = {
  name: '404',
};

export const FORBIDDEN = {
  name: '403',
};
